
export default class LauncherGenerator {
    /**
     * An asynchronous function that terminates when the class is initialized
     * to notify the user that application can be generated now
     */
    async getInitializationPromise() {
        return true;
    }

    /*
     * Generate application with all the parameters
     */
    async generateZip(parameters) {
        throw Error("Method generateZip() was not implemented");
    }

    /*
     * Generate project with all the parameters to be available for preview
     */
    async generatePreview(parameters) {
        throw Error("Method previewProject() was not implemented");
    }

    /*
     * Generate project difference with all the parameters
     */
    async generateDiff(parameters) {
        throw Error("Method diffProject() was not implemented");
    }

    /*
     * A private method for validating parameters
     */
    _validateParameters(parameters) {
        const nameRegex = /^[a-zA-Z0-9_\-$]+$/;
        const javaPackageRegex = /^[a-zA-Z0-9_$.]+$/;

        parameters.name = parameters.name.trim();
        parameters.package_ = parameters.package_.trim();

        if (!parameters.name) {
            throw new Error("Project name must be specified");
        } else if (!nameRegex.test(parameters.name)) {
            throw new Error("Project name can only contain characters a-z, A-Z, 0-9, $, - or _ and no spaces");
        }

        if (!parameters.package_) {
            throw new Error("Project package must be specified");
        } else if (!javaPackageRegex.test(parameters.package_)) {
            throw new Error("Project package can only contain identifiers formed of a-z, A-Z, 0-9, $ or _, and separated with '.'");
        }
    }
}
